export const breakPoint = {
    sm: 760,
    xs: 480
};
